$(() => {
    /**
     * Фильтрация опций в селекте
     * @param el - элемент, по которому был клик
     * @param text - искомый текст
     */
    function filterOptions(el, text) {
        const options = el.find(".select__box__options");
        text = (text || '').toLowerCase().trim();

        options.each(function () {
            if ($(this).text().toLowerCase().indexOf(text) > -1) {
                $(this).show();
            } else {
                $(this).hide();
            }
        })
    }

    /**
     * Сброс фильтрации
     * @param el
     */
    function unFilterOptions(el) {
        filterOptions(el, '');
    }

    const selDivs = $('.select');
    selDivs.css('cursor', 'pointer');

    // TODO: выяснить зачем это и убрать, если не надо, а то оригинальный селект и так скрыт даже без этого кода :)
    selDivs.children("select").css({
        opacity: "0",
        visibility: "hidden",
        position: "absolute",
    });

    selDivs.each(function () {
        const selectDiv = $(this);

        let selectedIndex = null;
        let selectedText = null;

        selectDiv
            .find("option")
            .each(function (i) {
                if (0 === i) {
                    selectDiv.prepend(
                        $("<div>", {
                            class: selectDiv
                                .attr("class")
                                .replace(/select/g, "select__box"),
                        })
                    );
                    var t = $(this).text();
                    selectDiv.prepend(
                        $("<span>", {
                            class: selectDiv
                                .attr("class")
                                .replace(/select/g, "select__placeholder"),
                            text: t,
                            css: {
                                'max-width': '330px',
                            },
                            "data-placeholder": t,
                        })
                    );
                }

                const el = $("<div>", {
                    class: selectDiv
                        .attr("class")
                        .replace(/select/g, `select__box__options`),
                    "data-city": i,
                    "data-quantity": $(this).data("quantity")
                })
                el.append($("<span>", {
                    text: $(this).text(),
                    "data-text": "",
                }))

                this.dataset.hasOwnProperty('outOfStock') && (el
                        .addClass('disabled')
                        .append(
                            $("<div>", {
                                class: "select__box__options--label out-of-stock",
                            }).append(
                                $("<span>", {
                                    text: "Распродано",
                                })
                            )
                        )
                )
                selectDiv.children("div").append(el);
                if ($(this).attr("selected")) {
                    selectedIndex = i;
                    selectedText = $(this).text();
                }
            }); // ./options each


        if (selectedIndex || selectedIndex === 0) {
            selectDiv.find(`.select__box__options:eq(${selectedIndex})`).addClass(
                "selected"
            );
            selectDiv.find(".select__placeholder").text(selectedText);
        }
    });


    selDivs.click(function () {
        const element = $(this);
        const placeholderElement = element.children(".select__placeholder");

        if (element.hasClass('active')) {
            element.removeClass("active");
            element.closest("section").removeClass("selsection");
        } else { // Если селект закрыт, то открываем его)
            selDivs.removeClass("active");
            element.addClass("active");
            element.closest("section").addClass("selsection");

            // Сбрасываем фильтр опций, чтоб показать все доступные
            unFilterOptions(element);

            // Блоки-селекты, у которых есть атрибут "searchable", должны быть с поиском :)
            if (this.hasAttribute('searchable')) {
                placeholderElement.attr('contenteditable', 'true').css('cursor', 'text').css('min-width', '166px');
                placeholderElement.attr('data-old-text', placeholderElement.text());
                placeholderElement.text('').focus();

                // При вводе фильтруем список опций по названию
                placeholderElement.on('input', function (e) {
                    filterOptions(element, placeholderElement.text());
                });
            }
        }

        placeholderElement.removeClass("error");
    });


    $(".select__box__options").click(function (event) {
        const el = $(this);
        var e = el.find("[data-text]").text(),
            i = el.index(),
            q = el.data("quantity");

        el.siblings(".select__box__options").removeClass("selected");
        el.addClass("selected");

        var t = el.closest(".select");
        var c = t.parent("div").children(".form-counter").children("input");
        c.attr("max", q);
        if (q <= c.val()) {
            c.val(q);
            c.parent().children(".increment").addClass("disabled");
        } else {
            c.parent().children(".increment").removeClass("disabled");
        }

        t.children("select")
            .removeClass("error")
            .prop("selectedIndex", i)
            .trigger("change");

        t.children("select")
            .closest(".select")
            .removeClass("error")
            .find("label.error")
            .remove();

        // Убираем редактируемость span, возвращаем курсор, устанавливаем текст, перестаём слушать событие input (даже если этого всего и не было :) )
        const placeholderElement = t.children(".select__placeholder");
        placeholderElement.text(e);
        setNotEditable(placeholderElement);
    });

    function setNotEditable(element) {
        element.attr('contenteditable', 'false')
            .css('cursor', 'pointer')
            .css('min-width', 'auto')
            .off('input');
    }

    function globalUnselect() {
        // Для всех селектов, которые с поиском, нужно определить активный и вернуть прежнее состояние выбора
        $('.select[searchable]').each(function (i, el) {
            el = $(el);
            if (!el.hasClass('active')) return;
            const placeholderElement = el.children(".select__placeholder");
            placeholderElement.text(placeholderElement.attr('data-old-text'));
            setNotEditable(placeholderElement);
        })
        selDivs.removeClass("active");
    }

    $(document).mouseup(function (e) {
        selDivs.is(e.target) ||
        0 !== selDivs.has(e.target).length ||
        globalUnselect();
    });
});
